import { SERVICES } from 'consts';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
const IS_PROD = SERVICES.envProfileService.envProfile === 'prod';
const prodAppId = '1:326211867669:web:296ef28d0d217222d52a1c';
const devAppId = '1:326211867669:web:46859b3a0225ff1dd52a1c';
const prodMeasurementId = 'G-EE40JZG5CE';
const devMeasurementId = 'G-Y7JRKWPYG0';
export const firebaseConfig = {
    apiKey: 'AIzaSyCeEHin6jQfd80aIY4GEhclMfFdK4n81Co',
    authDomain: 'ibam-d6cd2.firebaseapp.com',
    databaseURL: 'https://ibam-d6cd2.firebaseio.com',
    projectId: 'ibam-d6cd2',
    storageBucket: 'ibam-d6cd2.appspot.com',
    messagingSenderId: '326211867669',
    appId: IS_PROD ? prodAppId : devAppId,
    measurementId: IS_PROD ? prodMeasurementId : devMeasurementId
};
initializeApp(firebaseConfig);
const messaging = getMessaging();
export const requestForToken = async ()=>{
    try {
        if ('serviceWorker' in navigator) {
            const swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
            const currentToken = await getToken(messaging, {
                vapidKey: 'BHFekHbyH4bBzZlPvUOtAYL4xz_e2vb56k4U6ldRo1aM8Sz15HGodRgUzhVjd5eGieXBms_aOY8QEbKeqG6V71Q',
                serviceWorkerRegistration: swRegistration
            });
            if (currentToken) {
                localStorage.setItem('pushToken', currentToken);
            } else {
                console.log('No registration token available. Request permission to generate one.');
            }
        }
    } catch (error) {
        console.log('An error occurred while retrieving token. ', error);
    }
};
export const onMessageListener = ()=>new Promise((resolve)=>{
        onMessage(messaging, (payload)=>{
            resolve(payload);
        });
    });
